import React from 'react';
import { KannadaCCA2023 } from 'views/Literaryclub2023/components';

const LifeSkillPage = () => {
  return <KannadaCCA2023/>;
};

export default LifeSkillPage;